import type { IEmailSettingsData } from '../../common/interfaces/emailSetting';
import type { IKeyValuePair } from '../../common/interfaces/keyValuePair';
import {
    axiosDelete,
    get,
    post,
    put,
} from '../utility/Requests';
import { getIdentityBaseRoute } from './IdentityServiceUtils';

export const settingUrl = `/api/identity/Setting`;

// Helper function to get direct Identity service URL
const getDirectSettingUrl = (partitionGlobalId: string, isHostMode: boolean = false) => `${getIdentityBaseRoute(partitionGlobalId, isHostMode)}/api/Setting`;

export interface ISetting {
    id: number;
    key: string;
    value: string;
    partitionGlobalId: string;
    userId: string;
}

export interface ISettingPayload {
    settings: IKeyValuePair[];
    partitionGlobalId: string;
    userId?: string;
}

export function getSetting({
    key, partitionGlobalId, userId, isHostMode = false,
}: { url: string; key: string[]; partitionGlobalId: string; userId?: string; isHostMode?: boolean }) {
    const directUrl = getDirectSettingUrl(partitionGlobalId, isHostMode);
    return get<ISetting[]>(directUrl, {
        urlParams: {
            key,
            partitionGlobalId,
            userId,
        },
        ignoreBasePath: true,
    });
}

export function saveSetting(url: string, payload: ISettingPayload, isHostMode: boolean = false) {
    const directUrl = getDirectSettingUrl(payload.partitionGlobalId, isHostMode);
    return put<ISetting[]>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}

export function deleteSettings(key: string[], partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = getDirectSettingUrl(partitionGlobalId, isHostMode);
    return axiosDelete(directUrl, {
        body: {
            settings: key,
            partitionGlobalId,
        },
        ignoreBasePath: true,
    });
}

export function verifySmtpSettings(recipient: string, smtpSettings: IEmailSettingsData, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectSettingUrl(partitionGlobalId, isHostMode)}/VerifySmtpSettings`;
    return post(directUrl, {
        body: {
            recipient,
            smtpSettings,
        },
        ignoreBasePath: true,
    });
}
